import { useQuery } from "react-query";
import { AxiosError } from "axios";
import http from "infra/http";
import { ExportacaoContabilDto } from "./../typings/index";
import { FiltroExportacaoContabil } from "features/exportacao-contabil/typings";

function useExportacaoContabil(params: FiltroExportacaoContabil) {
  return useQuery<ExportacaoContabilDto, AxiosError>(
    [`/v1/contabilidade/exportacao-contabil`, params],
    async () => {
      const { data } = await http.get<ExportacaoContabilDto>(
        "/v1/contabilidade/exportacao-contabil",
        { params }
      );

      return data;
    },{
      enabled:!!params.dataInicio && !!params.dataFim,
    }
  );
}

export default useExportacaoContabil;
